<div id="ndvi-ndmi-distribution">
  @if (!loading) {
    @if (!selectedDay?.isCloudly && chartData?.length > 0) {
      <div class="pb-2">
        <span>
          <i class="ph-fill ph-question-mark"></i>
        </span>
        <span class="color-legend" (click)="openColorLegend()">{{
          'doktar_app.services.crop_monitoring.distribution_legend_question' | translate
        }}</span>
      </div>
      <div class="d-flex">
        <span>
          <i class="ph-fill ph-info"></i>
        </span>
        <span class="description">
          {{ 'doktar_app.services.crop_monitoring.distribution_chart_description' | translate }}:
          <span>
            @if (!loading) {
              {{ selectedDay?.imageDate | luxonFormat:'d MMMM y': ('UTC'+ plantationService.selectedPlantation?.offSet) }}
            } @else {
              <p-skeleton width="5rem" height="2rem" styleClass="mb-3" />
            }
          </span>
        </span>
      </div>
      <div>
        @if (showDistributionTabs) {
          <div class="diagram-tabs">
            <span class="tab" [class.active]="activeTab === 'relative'" (click)="onTabClick('relative')">{{
              'doktar_app.services.crop_monitoring.relative_distribution' | translate
            }}</span>
            <span class="tab" [class.active]="activeTab === 'absolute'" (click)="onTabClick('absolute')">{{
              'doktar_app.services.crop_monitoring.absolute_distribution' | translate
            }}</span>
          </div>
        }
        <div
          id="chart"
          echarts
          [options]="barChartOption"
          #chartContainer
          class="chart-container"
          style="height: 230px"></div>
        <div class="row px-5">
          @for (legendItem of legendItems; track legendItem) {
            <div class="col-3 dots">
              <span class="legendDot" [style.backgroundColor]="legendItem.color"></span>
              <span class="legendLabel">{{ legendItem.label | translate }}</span>
            </div>
          }
        </div>
      </div>
      <div class="d-flex mt-4">
        @if (selectedMapType?.key !== 'inspection') {
          <span>
            <i class="ph-fill ph-info"></i>
          </span>
          @if (activeTab === 'relative' && selectedMapType?.key !== 'ndmi') {
            <span>
              <p class="title mb-0">
                {{ 'doktar_app.services.crop_monitoring.relative_distribution_chart' | translate }}:
              </p>
              <p class="description">
                {{ 'doktar_app.services.crop_monitoring.relative_distribution_chart_description' | translate }}
              </p>
            </span>
          }
          @if (activeTab === 'absolute' || selectedMapType?.key === 'ndmi') {
            <span>
              <p class="title mb-0">
                {{ 'doktar_app.services.crop_monitoring.absolute_distribution_chart' | translate }}:
              </p>
              <p class="description">
                @if (selectedMapType?.key === 'ndmi') {
                  {{ 'doktar_app.services.crop_monitoring.absolute_distribution_chart_description_ndmi' | translate }}
                } @else {
                  {{ 'doktar_app.services.crop_monitoring.absolute_distribution_chart_description_ndvi' | translate }}
                }
              </p>
            </span>
          }
        } @else {
          <span>
            <i class="ph-fill ph-info"></i>
          </span>
          <span class="description">
            {{ 'doktar_app.services.crop_monitoring.absolute_distribution_chart_description_inspection' | translate }}
          </span>
        }
      </div>
    } @else {
      <app-no-analysis [selectedDay]="selectedDay" [isPreparing]="!(cropHealthData?.mapList?.length > 0)" />
    }
  } @else {
    <p-skeleton width="100%" height="15rem" styleClass="mb-3" />
    <p-skeleton width="100%" height="5rem" styleClass="mb-3" />
  }
</div>
